import React, { useState, useEffect, useRef,useContext } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import schoolApi from "../../api/schoolApi";
import { useOutletContext, useNavigate } from "react-router-dom";
import "../../App.css";
import { ToastContainer, toast } from "react-toastify";
import { SessionContext } from "../SessionProvider";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}
const InstallmentTable = () => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);

  const navigate = useNavigate();
  const [installments, setInstallments] = useState([]);
  const [headsArray, setHeadsArray] = useState([]);
  const [indexValues, setIndexValues] = useState([]);
  const [selectedStudent, setStudent] = useOutletContext();
  const [flag, setFlag] = useState(0);
  const [latejoineediscount, setLateJoineeDiscount] = useState(0);
  const [dissableins, setdissableins] = useState({});
  const [selectedReceiptData, setSelectedReceiptData] = useState(null);
  const receiptRef = useRef();
  
  console.log("selectedSessionId == ",selectedSessionId)
  console.log("selectedStudent == ",selectedStudent)

  useEffect(() => {
    initClass();
  }, [selectedStudent, selectedSessionId]);

  async function initClass() {
    try {
      let frequencySettings = 0;
      let lateFeeSettings = 0;
      const ResultSettings = await schoolApi.getAllSetting();
      if (ResultSettings.success) {
        frequencySettings = ResultSettings?.data?.filter(
          (res) => res.key === "frequency"
        )[0].value;
        lateFeeSettings = ResultSettings?.data?.filter(
          (res) => res.key === "late_fee"
        )[0].value;
      }

      const studentDetails = await schoolApi.fetchStudentsById(selectedStudent.id, selectedSessionId);
      console.log("studentDetails for session == ", studentDetails);

      const insResult = await schoolApi.getStudentFeeIntsallmentRecords(
        studentDetails?.studentRec?.student_addmission_id,
        selectedSessionId
      );
      console.log("inResult == ",insResult)

      if (insResult.success) {
      const currentDate = new Date();
      console.log("currentDate-->", currentDate);
      const currentYear = currentDate.getFullYear();

      insResult.result = insResult?.result?.map((is) => {
        insResult.result = insResult?.result?.map((is) => {
          if (
            !is.late_fee > 0 &&
            is.status === "pending" &&
            !selectedStudent.isrte
          ) {
            let latefee_is = 0;
            const dueDate = is?.due_date;

            if (dueDate) {
              const dueDateObj = new Date(dueDate);
              console.log("dueDateObj-->", dueDateObj);
              console.log(
                " dueDateObj.getFullYear()-->",
                dueDateObj.getFullYear()
              );
              //  if (
              //    dueDateObj.getFullYear() === currentYear &&
              //    dueDateObj < currentDate
              //  )
              if (
                //  dueDateObj.getFullYear() === currentYear &&
                dueDateObj < currentDate
              ) {
                console.log("i am here to set latefee");
                const differenceInDays = Math.ceil(
                  (currentDate - dueDateObj) / (1000 * 3600 * 24)
                );
                const netDueDays = parseInt(
                  (differenceInDays + parseInt(frequencySettings)) /
                    parseInt(frequencySettings)
                );
                latefee_is += Math.round(
                  netDueDays * parseInt(lateFeeSettings)
                );
              }
            }

            is.late_fee = latefee_is;
          }

          if (is.deposit_id && is.late_fee > 0) {
            let lateFeeHelper = insResult.result.filter(
              (ft) => ft.deposit_id === is.deposit_id
            );

            if (is.id !== lateFeeHelper[lateFeeHelper.length - 1].id) {
              return { ...is, late_fee: 0 };
            }
          }

          return { ...is };
        });
        if (is.deposit_id && is.late_fee > 0) {
          let lateFeeHelper = insResult.result.filter(
            (ft) => ft.deposit_id === is.deposit_id
          );

          if (is.id !== lateFeeHelper[lateFeeHelper.length - 1].id) {
            return { ...is, late_fee: 0 };
          }
        }

        return { ...is };
      });

      if (selectedStudent?.edit) {
        insResult.result = insResult.result.map((res) => {
          if (res.deposit_id === selectedStudent.deposit_id) {
            return { ...res, edit: true };
          } else {
            return { ...res, edit: false };
          }
        });
      }
      console.log("insResult ==>", insResult.result);
      console.log("insResult2 ==>", insResult.result[0].sessionid);

        setInstallments(insResult.result);
      }
      else{
        setInstallments([]);
      }
    } catch (error) {
      setInstallments([]);
      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  }
  const handleSaveDeposites = async (feeDeposit) => {
    try {
      console.log("feeDeposit.payment_method->", feeDeposit);

      if (
        !feeDeposit.netPayableAmount ||
        !feeDeposit.payment_date ||
        !feeDeposit.payment_method
      ) {
        return toast.error("Missing requirwed fields!!");
      }
      feeDeposit.amount = feeDeposit.netPayableAmount;

      const arr = {
        totalAmount: feeDeposit?.netPayableAmount,
        netPayableAmount: feeDeposit?.netPayableAmount,
        student_addmission_id: selectedStudent?.student_addmission_id,
        student_id: selectedStudent.student_id || selectedStudent.id,
        discount: feeDeposit?.discount,
        installments: feeDeposit?.installments,
        amount: feeDeposit?.netPayableAmount,
        late_joinee_discount: feeDeposit?.late_joinee_discount,
        sessionid: selectedStudent?.session_id,
        payment_date: feeDeposit?.payment_date,
        payment_method: feeDeposit?.payment_method,
        late_fee: feeDeposit?.late_fee ? feeDeposit?.late_fee : 0,
        remark: feeDeposit?.remark,
        due_amount: feeDeposit?.due_amount,
        transaction_no: feeDeposit?.transaction_no,
      };
      console.log("arr->", arr);

      if (arr) {
        const feeDepositResult = await schoolApi.createFeeDeposit(arr);

        if (feeDepositResult) {
          arr.deposit_id = feeDepositResult.deposit.id;
          if (feeDepositResult.deposit.id) {
            toast.success("Fees deposited successfully!!");
            setTimeout(() => {
              initClass();
            }, 2000);
          }
          // await handlePrintClick(arr);
        } else {
        }
      }
    } catch (error) {}
  };

  //-------------------- code pawan- ---------------------
  const feeDepositHandler = (installments) => {
    console.log("on depo-->", installments);

    const totals = {
      totalAmount: 0,
      discount: 0,
      previous_due: 0,
      due_amount: 0,
      totalTransportFee: 0,
      grossPayableAmount: 0,
      late_fee: 0,
      netPayableAmount: 0,
      amount: 0,
      payment_date: new Date(),
      payment_method: "Cash",
      late_joinee_discount: 0,
      installments: [],
      deposit_id: null,
    };

    const parseAmount = (amount) => parseInt(amount) || 0;

    installments?.forEach((res, index) => {
      totals.installments.push({ id: res?.id });
      totals.late_joinee_discount = parseAmount(res?.late_joinee_discount);
      totals.totalAmount +=
        parseAmount(res?.installment_amount) + parseAmount(res?.transport_fee);
      totals.discount += parseAmount(res?.discounted_amount);
      totals.previous_due += parseAmount(res?.previous_due);
      totals.totalTransportFee += parseAmount(res?.transport_fee);
      totals.grossPayableAmount += parseAmount(res?.grossPayableAmount);
      totals.netPayableAmount += parseAmount(res?.net_payable_amount);
      totals.deposit_id = res?.deposit_id ? res?.deposit_id : null;
      totals.due_amount = res?.due_amount ? res?.due_amount : 0;
      totals.late_fee += res?.late_fee ? res?.late_fee : 0;
    });

    // if (installments[0]?.edit) {
    //   console.log(
    //     "studentRecord?.payment_date ->",
    //     studentRecord?.payment_date
    //   );
    //   let paymentDate = null;
    //   if (studentRecord?.payment_date) {
    //     const [day, month, year] = studentRecord.payment_date.split("-");
    //     paymentDate = new Date(`${year}-${month}-${day}`);
    //     setReportData((prevState) => ({
    //       ...prevState,
    //       payment_date: paymentDate,
    //     }));
    //   }

    //   setFeeDeposit({
    //     totalAmount: totals?.totalAmount ? totals?.totalAmount : 0,
    //     late_joinee_discount: totals.late_joinee_discount
    //       ? totals.late_joinee_discount
    //       : 0,
    //     grossPayableAmount: totals?.grossPayableAmount
    //       ? totals?.grossPayableAmount
    //       : 0,
    //     amount: studentRecord?.amount ? studentRecord?.amount : 0,

    //     late_fee: parseInt(studentRecord?.late_fee)
    //       ? parseInt(studentRecord?.late_fee)
    //       : 0,
    //     payment_date: paymentDate,
    //     payment_method: studentRecord?.payment_method,
    //     deposit_id: studentRecord?.deposit_id,
    //     previous_due: studentRecord?.previous_due,
    //     discount: totals.discount ? totals.discount : 0,
    //     netPayableAmount: totals.netPayableAmount,
    //     installments: totals?.installments,
    //     totalTransportFee: totals.totalTransportFee,
    //     transaction_no: installments[0]?.transaction_no,
    //   });

    //   setTempAmount({
    //     totalAmount: totals?.totalAmount ? totals?.totalAmount : 0,
    //     grossPayableAmount: totals?.grossPayableAmount
    //       ? totals?.grossPayableAmount
    //       : 0,
    //     amount: studentRecord?.amount ? studentRecord?.amount : 0,
    //     late_fee: parseInt(studentRecord?.late_fee)
    //       ? parseInt(studentRecord?.late_fee)
    //       : 0,
    //     payment_date: paymentDate ? paymentDate : new Date(),
    //     payment_method: studentRecord?.payment_method,
    //     deposit_id: studentRecord?.deposit_id,
    //     discount: totals.discount ? totals.discount : 0,
    //     late_joinee_discount: totals.late_joinee_discount
    //       ? totals.late_joinee_discount
    //       : 0,
    //     netPayableAmount: totals.netPayableAmount,
    //     installments: totals?.installments,
    //     totalTransportFee: totals.totalTransportFee,
    //   });
    // } else {
    // setFeeDeposit(totals);
    // setTempAmount(totals);
    //}

    return totals;
  };

  console.log("installments ->", installments);
  async function payonline(feeDeposit) {
    let installment = [];

    installment.push(feeDeposit);
    let feeDepositNew = feeDepositHandler(installment);
    console.log("feeDepositNew-->", feeDepositNew);

    const amount = feeDeposit?.net_payable_amount;

    try {
      if (amount > 0) {
        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );
        if (!res) {
          alert("Razorpay failed to load!!");
          return;
        }

        const data = await schoolApi.FeeDepositOnline(amount);
        // if (data?.result?.id) navigate(`/razorpay-checkout/${data.result.id}`);
        const options = {
          key: "rzp_test_yDpYkhztZpWoC5",
          amount: amount * 100,
          currency: "INR",
          name: "Acme Corp",
          description: "Test Transaction",
          image: "https://example.com/your_logo",
          order_id: data.result.id,
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#3399cc",
          },
          handler: async function (response) {
            try {
              if (response.razorpay_payment_id) {
                feeDepositNew = {
                  ...feeDepositNew,
                  payment_method: "razorpay",
                  transaction_no: response.razorpay_payment_id,
                  payment_date: new Date(),
                };
                handleSaveDeposites(feeDepositNew);
                // toast.success("payment successfully");
              } else {
                toast.error("payment not acctepable");
              }
            } catch (error) {
              toast.error("Something went wrong while saving payment.");
            }
          },
          prefill: {
            name: feeDeposit?.student_name,
            email: feeDeposit?.student_email,
            contact: feeDeposit?.student_contact,
          },
          modal: {
            ondismiss: function () {},
          },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } else {
        toast.error("Enter amount gerterthan zero");
      }
    } catch (error) {}
  }

  useEffect(() => {
    const headsSet = new Set();
    setLateJoineeDiscount(0);
    installments.forEach((item, index) => {
      let netpayableAmount = 0;
      let discount_head_id = [];
      let grossPayableAmount = 0;

      item?.discounts?.forEach((ds) => {
        discount_head_id.push({ id: ds.fee_head_id, percent: ds.percent });
      });

      item?.heads?.forEach((head) => {
        headsSet.add(head.headname);
      });
      grossPayableAmount +=
        parseInt(item.installment_amount) +
        parseInt(item.transport_fee ?? 0) -
        parseInt(item.installment_discount ?? 0);
      netpayableAmount +=
        grossPayableAmount +
        parseInt(item.previous_due ?? 0) +
        parseInt(item.late_fee ?? 0);
      item.net_payable_amount = netpayableAmount;
      item.discounted_amount = item.installment_discount ?? 0;
      item.grossPayableAmount = grossPayableAmount;
      if (item.late_joinee) {
        setLateJoineeDiscount(
          (prev) => prev + item.installment_amount + item.transport_fee
        );
      }
    });

    let dissable = installments?.filter(
      (vl) =>{ console.log("vl?.late_joinee->",vl?.late_joinee)
       return vl?.status !== "completed" && (vl.late_joinee === false || vl.late_joinee ===null)}
    )[0];
    
    console.log("disis ->",dissable);
    
    setdissableins(dissable);
    if (dissable) {
      dissable.isdissable = false;
    }

    headsSet.add("Transport Fee");
    headsSet.add("Total Amount");
    headsSet.add("Discount");
    headsSet.add("Late Fee");
    headsSet.add("Previous Due");
    headsSet.add("Net Payable Amount");
    headsSet.add("Deposited Amount");
    headsSet.add("Receipt Number");
    headsSet.add("Online Payment");

    setHeadsArray(Array.from(headsSet));
  }, [installments]);

  useEffect(() => {
    const selectedInstallments = [];
    if (indexValues.length) {
      if (flag <= 0) {
        selectedInstallments.push(
          installments.filter((res, index) =>
            indexValues.some((i) => i.index === index)
          )
        );
      }

      if (selectedInstallments.length) {
        // feeDepositHandler(selectedInstallments[0]);
      }
    }
  }, [indexValues]);

  const getFee = (item, headName, headFee) => {
    switch (headName) {
      case "Transport Fee":
        return formatNumberWithCommas(item.transport_fee);
      case "Previous Due":
        return formatNumberWithCommas(item?.previous_due) ?? 0;
      case "Deposited Amount":
        return formatNumberWithCommas(item?.deposited_amount) ?? 0;
      case "Net Payable Amount":
        return formatNumberWithCommas(item?.net_payable_amount) ?? 0;
      case "Discount":
        return formatNumberWithCommas(item?.discounted_amount) ?? 0;
      case "Total Amount":
        return formatNumberWithCommas(
          item.installment_amount + item.transport_fee
        );
      case "Late Fee":
        return item.late_fee ? formatNumberWithCommas(item.late_fee) : 0;
      case "Receipt Number":
        const row = item;
        return item.receipt_number
          ? ` ${item.receipt_number}`
          : // <Link to="#" state={{ row }} onClick={() => handlePrintClick(row)}>
            // </Link>
            "N/A";
      case "Online Payment":
        if (item.status === "completed") {
          return (
            <div className="w-100 d-flex justify-content-center">
              <span className="badge bg-success p-1 w-100" style={{ fontSize: "0.65rem" }}>
                Paid
              </span>
            </div>
          );
        } else if (item.status === "partial") {
          return (
            <div className="w-100 d-flex flex-column align-items-center gap-1">
              <span className="badge bg-warning text-dark p-1 w-100" style={{ fontSize: "0.65rem" }}>
                Partial
              </span>
              <Button
                variant="primary"
                size="sm"
                className="w-100 p-1 fw-bold"
                disabled={dissableins?.id !== item?.id || (item?.promotedstatus !== "null" && item?.promotedstatus)}
                onClick={() => payonline(item)}
                style={{ fontSize: "0.6rem", lineHeight: "1" }}
              >
                Pay Balance
              </Button>
            </div>
          );
        } else {
          return (
            <div className="w-100 d-flex justify-content-center">
              <Button
                variant="primary"
                size="sm"
                className="w-100 p-1 fw-bold"
                disabled={dissableins?.id !== item?.id || (item?.promotedstatus !== "null" && item?.promotedstatus)}
                onClick={() => payonline(item)}
                style={{ fontSize: "0.6rem", lineHeight: "1" }}
              >
                Pay Online
              </Button>
            </div>
          );
        }

      default:
        return headFee;
    }
  };

  const handleChange = (e, month, index) => {
    const { checked } = e.target;
    setInstallments((prevInstallments) => {
      const updatedInstallments = [...prevInstallments];
      const selectedInstallments = [];
      updatedInstallments[index].isCheked = checked;

      if (checked) {
        if (index + 1 < updatedInstallments.length) {
          updatedInstallments[index + 1].isdissable = false;
        }
      } else {
        for (var i = index + 1; i < updatedInstallments.length; i++) {
          updatedInstallments[i].isCheked = checked;
          updatedInstallments[i].isdissable = true;
        }
      }

      let dissable = installments?.filter((vl) => vl?.late_joinee === false)[0];
      if (
        selectedInstallments[0].length > 0 &&
        dissable?.id === selectedInstallments[0][0]?.id
      ) {
        selectedInstallments[0][0].late_joinee_discount = latejoineediscount;
      }
      // feeDepositHandler(selectedInstallments[0]);
      return updatedInstallments;
    });
  };

  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
    documentTitle: "FeeReceipt",
    onAfterPrint: () => {
      setSelectedReceiptData(null);
    },
  });

  const handlePrintClick = (data) => {
    setSelectedReceiptData(data);
    const timer = setTimeout(() => {
      handlePrint();
    }, 200);
    return () => clearTimeout(timer);
  };

  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };

  console.log("installments-->", installments);

  return (
    <div style={{ overflowY: "auto" }} className="mx-2">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Table striped bordered hover id="myTable">
        <thead style={{ marginLeft: "100px", width: "90px" }}>
          <tr>
            <th
              style={{
                whiteSpace: "nowrap",
                backgroundColor: "#637384",
                color: "white",
                textAlign: "center",
              }}
            >
              Heads
            </th>
            {installments.map((item, index) => (
              <th
                style={{
                  whiteSpace: "nowrap",
                  backgroundColor: "#637384",
                  color: "white",
                  textAlign: "center",
                }}
                key={item.id}
              >
                {item.month}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {console.log("headarray", headsArray)}
          {headsArray.map((headName) => (
            <tr key={headName}>
              <td style={{ wordBreak: "break-word"}}>{headName}</td>
              {installments.map((item) => {
                const head = item.heads.find((h) => h.headname === headName);
                const headFee = head ? head.head_amount : 0;
                return (
                  <td key={item.id} className="text-end" >
                    {getFee(item, headName, formatNumberWithCommas(headFee))}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>
      {selectedReceiptData && (
        <div style={{ display: "none" }}>
          {/* <FeeReceipt ref={receiptRef} receiptData={selectedReceiptData} /> */}
        </div>
      )}
    </div>
  );
};
export default InstallmentTable;

// /**
//  * @author: Pawan Singh Sisodiya
//  */

// import React, { useState, useEffect, useRef } from "react";
// import { Button, Form, Table } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import { useReactToPrint } from "react-to-print";
// import schoolApi from "../../api/schoolApi";
// import { useOutletContext, useNavigate } from "react-router-dom";
// // import FeeReceipt from "./FeeReceipt.jsx";
// import "../../App.css";
// import { ToastContainer, toast } from "react-toastify";
// function loadScript(src) {
//   return new Promise((resolve) => {
//     const script = document.createElement("script");
//     script.src = src;
//     script.onload = () => {
//       resolve(true);
//     };
//     script.onerror = () => {
//       resolve(false);
//     };
//     document.body.appendChild(script);
//   });
// }
// const InstallmentTable = () => {
//   const navigate = useNavigate();
//   const [installments, setInstallments] = useState([]);
//   const [headsArray, setHeadsArray] = useState([]);
//   const [indexValues, setIndexValues] = useState([]);
//   const [selectedStudent, setStudent] = useOutletContext();
//   const [flag, setFlag] = useState(0);
//   // const [feeDeposit, setFeeDeposit] = useState({});

//   const [latejoineediscount, setLateJoineeDiscount] = useState(0);
//   const [dissableins, setdissableins] = useState({});
//   const [selectedReceiptData, setSelectedReceiptData] = useState(null);
//   const receiptRef = useRef();
//   // edit = edit === undefined ? false : edit;
//   useEffect(() => {
//     initClass();
//   }, [selectedStudent]);

//   async function initClass() {
//     try {
//       // setdisablebutton(false);

//       let frequencySettings = 0;
//       let lateFeeSettings = 0;
//       const ResultSettings = await schoolApi.getAllSetting();
//       if (ResultSettings.success) {
//         frequencySettings = ResultSettings?.data?.filter(
//           (res) => res.key === "frequency"
//         )[0].value;
//         lateFeeSettings = ResultSettings?.data?.filter(
//           (res) => res.key === "late_fee"
//         )[0].value;
//       }

//       const insResult = await schoolApi.getStudentFeeIntsallmentRecords(
//         selectedStudent.addmission_id
//           ? selectedStudent.addmission_id
//           : selectedStudent.student_addmission_id,
//         selectedStudent.session_id
//       );

//       const currentDate = new Date();
//       console.log("currentDate-->", currentDate);
//       const currentYear = currentDate.getFullYear();

//       insResult.result = insResult?.result?.map((is) => {
//         insResult.result = insResult?.result?.map((is) => {
//           if (
//             !is.late_fee > 0 &&
//             is.status === "pending" &&
//             !selectedStudent.isrte
//           ) {
//             let latefee_is = 0;
//             const dueDate = is?.due_date;

//             if (dueDate) {
//               const dueDateObj = new Date(dueDate);
//               console.log("dueDateObj-->", dueDateObj);
//               console.log(
//                 " dueDateObj.getFullYear()-->",
//                 dueDateObj.getFullYear()
//               );
//               //  if (
//               //    dueDateObj.getFullYear() === currentYear &&
//               //    dueDateObj < currentDate
//               //  )
//               if (
//                 //  dueDateObj.getFullYear() === currentYear &&
//                 dueDateObj < currentDate
//               ) {
//                 console.log("i am here to set latefee");
//                 const differenceInDays = Math.ceil(
//                   (currentDate - dueDateObj) / (1000 * 3600 * 24)
//                 );
//                 const netDueDays = parseInt(
//                   (differenceInDays + parseInt(frequencySettings)) /
//                     parseInt(frequencySettings)
//                 );
//                 latefee_is += Math.round(
//                   netDueDays * parseInt(lateFeeSettings)
//                 );
//               }
//             }

//             is.late_fee = latefee_is;
//           }

//           if (is.deposit_id && is.late_fee > 0) {
//             let lateFeeHelper = insResult.result.filter(
//               (ft) => ft.deposit_id === is.deposit_id
//             );

//             if (is.id !== lateFeeHelper[lateFeeHelper.length - 1].id) {
//               return { ...is, late_fee: 0 };
//             }
//           }

//           return { ...is };
//         });
//         if (is.deposit_id && is.late_fee > 0) {
//           let lateFeeHelper = insResult.result.filter(
//             (ft) => ft.deposit_id === is.deposit_id
//           );

//           if (is.id !== lateFeeHelper[lateFeeHelper.length - 1].id) {
//             return { ...is, late_fee: 0 };
//           }
//         }

//         return { ...is };
//       });

//       if (selectedStudent?.edit) {
//         insResult.result = insResult.result.map((res) => {
//           if (res.deposit_id === selectedStudent.deposit_id) {
//             return { ...res, edit: true };
//           } else {
//             return { ...res, edit: false };
//           }
//         });
//       }
//       console.log("insResult ==>", insResult);

//       if (insResult.success) {
//         setInstallments(insResult.result);
//       }
//     } catch (error) {
//       if (error?.response?.status === 401) {
//         navigate("/login");
//       }
//     }
//   }
//   const handleSaveDeposites = async (feeDeposit) => {
//     try {
//       console.log("feeDeposit.payment_method->", feeDeposit);

//       if (
//         !feeDeposit.netPayableAmount ||
//         !feeDeposit.payment_date ||
//         !feeDeposit.payment_method
//       ) {
//         return toast.error("Missing requirwed fields!!");
//       }
//       feeDeposit.amount = feeDeposit.netPayableAmount;

//       const arr = {
//         totalAmount: feeDeposit?.netPayableAmount,
//         netPayableAmount: feeDeposit?.netPayableAmount,
//         student_addmission_id: selectedStudent?.student_addmission_id,
//         student_id: selectedStudent.student_id || selectedStudent.id,
//         discount: feeDeposit?.discount,
//         installments: feeDeposit?.installments,
//         amount: feeDeposit?.netPayableAmount,
//         late_joinee_discount: feeDeposit?.late_joinee_discount,
//         sessionid: selectedStudent?.session_id,
//         payment_date: feeDeposit?.payment_date,
//         payment_method: feeDeposit?.payment_method,
//         late_fee: feeDeposit?.late_fee ? feeDeposit?.late_fee : 0,
//         remark: feeDeposit?.remark,
//         due_amount: feeDeposit?.due_amount,
//         transaction_no: feeDeposit?.transaction_no,
//       };
//       console.log("arr->", arr);

//       if (arr) {
//         const feeDepositResult = await schoolApi.createFeeDeposit(arr);

//         if (feeDepositResult) {
//           arr.deposit_id = feeDepositResult.deposit.id;
//           if (feeDepositResult.deposit.id) {
//             toast.success("Fees deposited successfully!!");
//             setTimeout(() => {
//               initClass();
//             }, 2000);
//           }
//           // await handlePrintClick(arr);
//         } else {
//         }
//       }
//     } catch (error) {}
//   };

//   //-------------------- code pawan- ---------------------
//   const feeDepositHandler = (installments) => {
//     console.log("on depo-->", installments);

//     const totals = {
//       totalAmount: 0,
//       discount: 0,
//       previous_due: 0,
//       due_amount: 0,
//       totalTransportFee: 0,
//       grossPayableAmount: 0,
//       late_fee: 0,
//       netPayableAmount: 0,
//       amount: 0,
//       payment_date: new Date(),
//       payment_method: "Cash",
//       late_joinee_discount: 0,
//       installments: [],
//       deposit_id: null,
//     };

//     const parseAmount = (amount) => parseInt(amount) || 0;

//     installments?.forEach((res, index) => {
//       totals.installments.push({ id: res?.id });
//       totals.late_joinee_discount = parseAmount(res?.late_joinee_discount);
//       totals.totalAmount +=
//         parseAmount(res?.installment_amount) + parseAmount(res?.transport_fee);
//       totals.discount += parseAmount(res?.discounted_amount);
//       totals.previous_due += parseAmount(res?.previous_due);
//       totals.totalTransportFee += parseAmount(res?.transport_fee);
//       totals.grossPayableAmount += parseAmount(res?.grossPayableAmount);
//       totals.netPayableAmount += parseAmount(res?.net_payable_amount);
//       totals.deposit_id = res?.deposit_id ? res?.deposit_id : null;
//       totals.due_amount = res?.due_amount ? res?.due_amount : 0;
//       totals.late_fee += res?.late_fee ? res?.late_fee : 0;
//     });

//     // if (installments[0]?.edit) {
//     //   console.log(
//     //     "studentRecord?.payment_date ->",
//     //     studentRecord?.payment_date
//     //   );
//     //   let paymentDate = null;
//     //   if (studentRecord?.payment_date) {
//     //     const [day, month, year] = studentRecord.payment_date.split("-");
//     //     paymentDate = new Date(`${year}-${month}-${day}`);
//     //     setReportData((prevState) => ({
//     //       ...prevState,
//     //       payment_date: paymentDate,
//     //     }));
//     //   }

//     //   setFeeDeposit({
//     //     totalAmount: totals?.totalAmount ? totals?.totalAmount : 0,
//     //     late_joinee_discount: totals.late_joinee_discount
//     //       ? totals.late_joinee_discount
//     //       : 0,
//     //     grossPayableAmount: totals?.grossPayableAmount
//     //       ? totals?.grossPayableAmount
//     //       : 0,
//     //     amount: studentRecord?.amount ? studentRecord?.amount : 0,

//     //     late_fee: parseInt(studentRecord?.late_fee)
//     //       ? parseInt(studentRecord?.late_fee)
//     //       : 0,
//     //     payment_date: paymentDate,
//     //     payment_method: studentRecord?.payment_method,
//     //     deposit_id: studentRecord?.deposit_id,
//     //     previous_due: studentRecord?.previous_due,
//     //     discount: totals.discount ? totals.discount : 0,
//     //     netPayableAmount: totals.netPayableAmount,
//     //     installments: totals?.installments,
//     //     totalTransportFee: totals.totalTransportFee,
//     //     transaction_no: installments[0]?.transaction_no,
//     //   });

//     //   setTempAmount({
//     //     totalAmount: totals?.totalAmount ? totals?.totalAmount : 0,
//     //     grossPayableAmount: totals?.grossPayableAmount
//     //       ? totals?.grossPayableAmount
//     //       : 0,
//     //     amount: studentRecord?.amount ? studentRecord?.amount : 0,
//     //     late_fee: parseInt(studentRecord?.late_fee)
//     //       ? parseInt(studentRecord?.late_fee)
//     //       : 0,
//     //     payment_date: paymentDate ? paymentDate : new Date(),
//     //     payment_method: studentRecord?.payment_method,
//     //     deposit_id: studentRecord?.deposit_id,
//     //     discount: totals.discount ? totals.discount : 0,
//     //     late_joinee_discount: totals.late_joinee_discount
//     //       ? totals.late_joinee_discount
//     //       : 0,
//     //     netPayableAmount: totals.netPayableAmount,
//     //     installments: totals?.installments,
//     //     totalTransportFee: totals.totalTransportFee,
//     //   });
//     // } else {
//     // setFeeDeposit(totals);
//     // setTempAmount(totals);
//     //}

//     return totals;
//   };

//   console.log("installments ->", installments);
//   async function payonline(feeDeposit) {
//     let installment = [];

//     installment.push(feeDeposit);
//     let feeDepositNew = feeDepositHandler(installment);
//     console.log("feeDepositNew-->", feeDepositNew);

//     const amount = feeDeposit?.net_payable_amount;

//     try {
//       if (amount > 0) {
//         const res = await loadScript(
//           "https://checkout.razorpay.com/v1/checkout.js"
//         );
//         if (!res) {
//           alert("Razorpay failed to load!!");
//           return;
//         }

//         const data = await schoolApi.FeeDepositOnline(amount);
//         // if (data?.result?.id) navigate(`/razorpay-checkout/${data.result.id}`);
//         const options = {
//           key: "rzp_test_yDpYkhztZpWoC5",
//           amount: amount * 100,
//           currency: "INR",
//           name: "Acme Corp",
//           description: "Test Transaction",
//           image: "https://example.com/your_logo",
//           order_id: data.result.id,
//           notes: {
//             address: "Razorpay Corporate Office",
//           },
//           theme: {
//             color: "#3399cc",
//           },
//           handler: async function (response) {
//             try {
//               if (response.razorpay_payment_id) {
//                 feeDepositNew = {
//                   ...feeDepositNew,
//                   payment_method: "razorpay",
//                   transaction_no: response.razorpay_payment_id,
//                   payment_date: new Date(),
//                 };
//                 handleSaveDeposites(feeDepositNew);
//                 toast.success("payment successfully");
//               } else {
//                 toast.error("payment not acctepable");
//               }
//             } catch (error) {
//               toast.error("Something went wrong while saving payment.");
//             }
//           },
//           prefill: {
//             name: feeDeposit?.student_name,
//             email: feeDeposit?.student_email,
//             contact: feeDeposit?.student_contact,
//           },
//           modal: {
//             ondismiss: function () {},
//           },
//         };

//         const paymentObject = new window.Razorpay(options);
//         paymentObject.open();
//       } else {
//         toast.error("Enter amount gerterthan zero");
//       }
//     } catch (error) {}
//   }
//   useEffect(() => {
//     const headsSet = new Set();
//     setLateJoineeDiscount(0);
//     installments.forEach((item, index) => {
//       let netpayableAmount = 0;
//       let discount_head_id = [];
//       let grossPayableAmount = 0;

//       item?.discounts?.forEach((ds) => {
//         discount_head_id.push({ id: ds.fee_head_id, percent: ds.percent });
//       });

//       item?.heads?.forEach((head) => {
//         headsSet.add(head.headname);
//       });
//       grossPayableAmount +=
//         parseInt(item.installment_amount) +
//         parseInt(item.transport_fee ?? 0) -
//         parseInt(item.installment_discount ?? 0);
//       netpayableAmount +=
//         grossPayableAmount +
//         parseInt(item.previous_due ?? 0) +
//         parseInt(item.late_fee ?? 0);
//       item.net_payable_amount = netpayableAmount;
//       item.discounted_amount = item.installment_discount ?? 0;
//       item.grossPayableAmount = grossPayableAmount;
//       if (item.late_joinee) {
//         setLateJoineeDiscount(
//           (prev) => prev + item.installment_amount + item.transport_fee
//         );
//       }
//     });

//     let dissable = installments?.filter(
//       (vl) => vl?.status !== "completed" && vl?.late_joinee === false
//     )[0];
//     setdissableins(dissable);
//     if (dissable) {
//       dissable.isdissable = false;
//     }

//     headsSet.add("Transport Fee");
//     headsSet.add("Total Amount");
//     headsSet.add("Discount");
//     headsSet.add("Late Fee");
//     headsSet.add("Previous Due");
//     headsSet.add("Net Payable Amount");
//     headsSet.add("Deposited Amount");
//     headsSet.add("Receipt Number");
//     headsSet.add("Online Payment");

//     setHeadsArray(Array.from(headsSet));
//   }, [installments]);

//   useEffect(() => {
//     const selectedInstallments = [];
//     if (indexValues.length) {
//       if (flag <= 0) {
//         selectedInstallments.push(
//           installments.filter((res, index) =>
//             indexValues.some((i) => i.index === index)
//           )
//         );
//       }

//       if (selectedInstallments.length) {
//         // feeDepositHandler(selectedInstallments[0]);
//       }
//     }
//   }, [indexValues]);

//   const getFee = (item, headName, headFee) => {
//     switch (headName) {
//       case "Transport Fee":
//         return formatNumberWithCommas(item.transport_fee);
//       case "Previous Due":
//         return formatNumberWithCommas(item?.previous_due) ?? 0;
//       case "Deposited Amount":
//         return formatNumberWithCommas(item?.deposited_amount) ?? 0;
//       case "Net Payable Amount":
//         return formatNumberWithCommas(item?.net_payable_amount) ?? 0;
//       case "Discount":
//         return formatNumberWithCommas(item?.discounted_amount) ?? 0;
//       case "Total Amount":
//         return formatNumberWithCommas(
//           item.installment_amount + item.transport_fee
//         );
//       case "Late Fee":
//         return item.late_fee ? formatNumberWithCommas(item.late_fee) : 0;
//       case "Receipt Number":
//         const row = item;
//         return item.receipt_number
//           ? ` ${item.receipt_number}`
//           : // <Link to="#" state={{ row }} onClick={() => handlePrintClick(row)}>
//             // </Link>
//             "N/A";
//       case "Online Payment":
//         return item.receipt_number ? (
//           <Button variant="success" disabled>
//             Paid
//           </Button>
//         ) : (
//           <Button
//             variant="primary"
//             disabled={dissableins?.id !== item?.id}
//             onClick={() => payonline(item)}
//           >
//             Pay Online
//           </Button>
//         );

//       default:
//         return headFee;
//     }
//   };

//   const handleChange = (e, month, index) => {
//     const { checked } = e.target;
//     setInstallments((prevInstallments) => {
//       const updatedInstallments = [...prevInstallments];
//       const selectedInstallments = [];
//       updatedInstallments[index].isCheked = checked;

//       if (checked) {
//         if (index + 1 < updatedInstallments.length) {
//           updatedInstallments[index + 1].isdissable = false;
//         }
//       } else {
//         for (var i = index + 1; i < updatedInstallments.length; i++) {
//           updatedInstallments[i].isCheked = checked;
//           updatedInstallments[i].isdissable = true;
//         }
//       }

//       let dissable = installments?.filter((vl) => vl?.late_joinee === false)[0];
//       if (
//         selectedInstallments[0].length > 0 &&
//         dissable?.id === selectedInstallments[0][0]?.id
//       ) {
//         selectedInstallments[0][0].late_joinee_discount = latejoineediscount;
//       }
//       // feeDepositHandler(selectedInstallments[0]);
//       return updatedInstallments;
//     });
//   };

//   const handlePrint = useReactToPrint({
//     content: () => receiptRef.current,
//     documentTitle: "FeeReceipt",
//     onAfterPrint: () => {
//       setSelectedReceiptData(null);
//     },
//   });

//   const handlePrintClick = (data) => {
//     setSelectedReceiptData(data);
//     const timer = setTimeout(() => {
//       handlePrint();
//     }, 200);
//     return () => clearTimeout(timer);
//   };

//   const formatNumberWithCommas = (number) => {
//     return number ? number.toLocaleString("en-IN") : "0";
//   };

//   console.log("installments-->", installments);

//   return (
//     <div style={{ overflowY: "auto" }} className="mx-2">
//       <ToastContainer
//         position="top-right"
//         autoClose={2000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="light"
//       />
//       <Table striped bordered hover id="myTable">
//         <thead style={{ marginLeft: "100px", width: "90px" }}>
//           <tr>
//             <th
//               style={{
//                 whiteSpace: "nowrap",
//                 backgroundColor: "#637384",
//                 color: "white",
//                 textAlign: "center",
//               }}
//             >
//               Heads
//             </th>
//             {installments.map((item, index) => (
//               <th
//                 style={{
//                   whiteSpace: "nowrap",
//                   backgroundColor: "#637384",
//                   color: "white",
//                   textAlign: "center",
//                 }}
//                 key={item.id}
//               >
//                 {item.month}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody style={{ width: "140px" }}>
//           {console.log("headarray", headsArray)}
//           {headsArray.map((headName) => (
//             <tr key={headName}>
//               <td>{headName}</td>
//               {installments.map((item) => {
//                 const head = item.heads.find((h) => h.headname === headName);
//                 const headFee = head ? head.head_amount : 0;
//                 return (
//                   <td key={item.id} className="text-end">
//                     {getFee(item, headName, formatNumberWithCommas(headFee))}
//                   </td>
//                 );
//               })}
//             </tr>
//           ))}
//         </tbody>
//       </Table>
//       {selectedReceiptData && (
//         <div style={{ display: "none" }}>
//           {/* <FeeReceipt ref={receiptRef} receiptData={selectedReceiptData} /> */}
//         </div>
//       )}
//     </div>
//   );
// };

// export default InstallmentTable;
